import { useLayoutEffect, useRef, useMemo } from 'react';
import { useDebounce } from '../../utils';
export var useWidth = function () {
    var _a, _b;
    var ref = useRef(null);
    // * Debounced width setter to avoid performance overhead on resize events
    var _c = useDebounce((_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.clientHeight) !== null && _b !== void 0 ? _b : 0), width = _c[0], setWidth = _c[1];
    var element = ref.current;
    if (element !== null && width !== (element === null || element === void 0 ? void 0 : element.clientWidth)) {
        setWidth(element === null || element === void 0 ? void 0 : element.clientWidth, { immediate: true });
    }
    var resizeObserver = useMemo(function () {
        var ResizeObserver = global.ResizeObserver;
        return new ResizeObserver(function (entries) {
            if (!Array.isArray(entries))
                return;
            if (entries.length < 1)
                return;
            var entry = entries[0];
            setWidth(entry.contentRect.width);
        });
    }, []);
    useLayoutEffect(function () {
        // * Bind width state to resize observer on container element
        if (element !== null) {
            resizeObserver.observe(element);
            return function () { return resizeObserver.unobserve(element); };
        }
        return function () { };
    }, [element]);
    return {
        width: width,
        containerRef: ref
    };
};
//# sourceMappingURL=useWidth.js.map